/* eslint-disable react/self-closing-comp */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable arrow-body-style */
/* eslint-disable import/order */
/* eslint-disable default-case */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/button-has-type */
/* eslint-disable no-unreachable */
/* eslint-disable no-else-return */
import PropTypes from 'prop-types';
import React, { useState, useCallback, useMemo, useRef, useEffect } from "react";
import { flexRender } from "@tanstack/react-table";
import { useSelector } from 'react-redux';
// mui
import { Close as CloseIcon, Clear as ClearIcon } from "@mui/icons-material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, TableCell, Stack, IconButton, Checkbox, TextField, Tooltip, Chip, Button, Typography, Paper } from "@mui/material";
// component
import Iconify from '../iconify';
// -----------------------------------------------------------------------------------------------------

Format.propTypes = {
    cell: PropTypes.object.isRequired,
};

Filter.propTypes = {
    column: PropTypes.object.isRequired,
    myFilterFn: PropTypes.func,
    setLoading: PropTypes.func,
    handleFilterClose: PropTypes.func,
    setSelectedRows: PropTypes.func,
};

DebouncedInput.propTypes = {
    value: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired,
    debounce: PropTypes.number,
    style: PropTypes.object,
};
// -----------------------------------------------------------------------------------------------------

const handleCellCopy = (text) => {
    navigator.clipboard.writeText(text);
};

export function GetValidatedComponent({ value: cellvalue }) {
    if (cellvalue === 1) {
        return (
            <Iconify icon="octicon:dot-fill-16" width='20px' height='20px' color="success.main" />
        );
    }

    if (cellvalue === 2) {
        return (
            <Iconify icon="octicon:dot-fill-16" width='20px' height='20px' color="#ffcd38" />

        );
    }
    if (cellvalue === 3) {
        return (
            <Iconify icon="octicon:dot-fill-16" width='20px' height='20px' color="#9e9e9e" />

        );
    }
    if (cellvalue === 4) {
        return (
            <Iconify icon="octicon:dot-fill-16" width='20px' height='20px' color="error.main" />

        );
    }
    GetValidatedComponent.propTypes = {
        value: PropTypes.number.isRequired,
    };
}
// Format Component
function Format({ cell }) {
    const { formatVariant } = cell.column.columnDef.meta ?? {}
    let cellTextValue;
    let toolTipText = "";
    const isPinned = cell.column.getIsPinned?.();
    const pinStyles = isPinned ? { position: 'sticky', left: isPinned === 'left' ? 0 : undefined, backgroundColor: 'white' } : {};

    if (formatVariant === "numeric") {
        const accessorKey = cell.column.columnDef.accessorKey;
        const value = cell.row.original[accessorKey];

        // Columns that should NOT have thousand separators
        const plainColumns = ["conversionFactor", "territorySeqNo", "distributorCode"];

        if (value == null || value === '') {
            cellTextValue = '';
        }
        else if (plainColumns.includes(accessorKey)) {
            // Show raw value
            cellTextValue = value;
        }
        else {
            // Show numeric value WITHOUT decimals
            cellTextValue = Number(value).toLocaleString("en-IN", { maximumFractionDigits: 0 });
        }

        toolTipText = cellTextValue;
    }
    else if (formatVariant === "integer") {
        const value = cell.row.original[cell.column.columnDef.accessorKey];

        cellTextValue = value != null && !isNaN(value)
            ? Number(value).toLocaleString("en-IN", {
                maximumFractionDigits: 0,
            })
            : '';

        toolTipText = cellTextValue;
    }
    else if (formatVariant === "decimalnumber") {
        const value = cell.row.original[cell.column.columnDef.accessorKey];
        cellTextValue = value != null && !isNaN(value)
            ? Number(value).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })
            : '';

        toolTipText = cellTextValue;
    }
    else if (formatVariant === "percentage") {
        const rawValue = cell.row.original[cell.column.columnDef.accessorKey];

        if (rawValue == null || rawValue === '') {
            cellTextValue = '';
            toolTipText = '';
        } else {
            const num = Number(String(rawValue).replace('%', ''));

            if (Number.isNaN(num)) {
                cellTextValue = '';
                toolTipText = '';
            } else {
                const formatted = `${num.toFixed(2)}%`;
                cellTextValue = formatted;
                toolTipText = formatted;
            }
        }
    }
    else if (formatVariant === 'date') {
        const rawValue = cell.row.original[cell.column.columnDef.accessorKey];

        if (!rawValue || rawValue === 'null' || rawValue === 'undefined') {
            cellTextValue = '';
            toolTipText = '';
        } else {
            const date = new Date(rawValue);

            // Check if the date is valid
            if (isNaN(date.getTime())) {
                cellTextValue = '';
                toolTipText = '';
            } else {
                const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                const day = String(date.getDate()).padStart(2, '0');
                const month = monthNames[date.getMonth()];
                const year = date.getFullYear();
                const formattedDate = `${day}-${month}-${year}`;
                cellTextValue = formattedDate;
                toolTipText = formattedDate;
            }
        }
    }
    else if (formatVariant === 'datetime') {
        const rawValue = cell.row.original[cell.column.columnDef.accessorKey];

        if (!rawValue) {
            cellTextValue = '';
            toolTipText = '';
        } else {
            const date = new Date(rawValue);
            if (Number.isNaN(date.getTime())) {
                cellTextValue = '';
                toolTipText = '';
            } else {
                const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                const pad = (n) => String(n).padStart(2, '0');
                const day = pad(date.getDate());
                const month = monthNames[date.getMonth()];
                const year = date.getFullYear();
                const hours = pad(date.getHours());
                const minutes = pad(date.getMinutes());
                const seconds = pad(date.getSeconds());
                const formattedDateTime = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
                cellTextValue = formattedDateTime;
                toolTipText = formattedDateTime;
            }
        }
    }
    else if (formatVariant === 'monthdate') {
        const rawValue = cell.row.original[cell.column.columnDef.accessorKey];

        if (!rawValue || rawValue === 'null' || rawValue === 'undefined') {
            cellTextValue = '';
            toolTipText = '';
        } else {
            const date = new Date(rawValue);

            if (isNaN(date.getTime())) {
                cellTextValue = '';
                toolTipText = '';
            } else {
                const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                const month = monthNames[date.getMonth()];
                const year = date.getFullYear();
                const formattedMonth = `${month}-${year}`;
                cellTextValue = formattedMonth;
                toolTipText = formattedMonth;
            }
        }
    }
    else {
        cellTextValue = flexRender(cell.column.columnDef.cell, cell.getContext())
        toolTipText = cell.getValue(cell.column.columnDef.accessorKey) ?? '';
    }

    const commonStyle = {
        ...pinStyles,
        border: "1px solid #ccc",
        textAlign: cell.column.columnDef.textAlign,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100px",
    };

    return cellTextValue?.props?.column?.columnDef?.id === "select" || toolTipText === "" || toolTipText === null || toolTipText === undefined || cellTextValue?.props?.column?.columnDef?.id === "details" || cellTextValue?.props?.column?.columnDef?.id === "file" ?
        (
            <TableCell
                className="rowStyle"
                style={commonStyle}
            >
                {cellTextValue}
            </TableCell>
        ) : (
            <Tooltip
                key={cell.id}
                title={
                    <Stack direction="row" sx={{ maxWidth: "300px", whiteSpace: "pre-wrap", wordWrap: "break-word", alignItems: "center", }}>
                        <span style={{ flex: 1, overflow: "hidden" }}>
                            {cellTextValue}
                            <IconButton size="small" onClick={(e) => { e.stopPropagation(); handleCellCopy(toolTipText); }}>
                                <ContentCopyIcon fontSize="small" />
                            </IconButton>
                        </span>
                    </Stack>
                }
                PopperProps={{
                    modifiers: [
                        {
                            name: "preventOverflow",
                            options: {
                                boundary: "window",
                            },
                        },
                    ],
                }}
                enterTouchDelay={50}
                leaveTouchDelay={3000}
                interactive
            >
                <TableCell
                    className="rowStyle"
                    style={{
                        border: "1px solid #ccc",
                        textAlign: cell.column.columnDef.textAlign,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "100px",
                    }}
                >
                    {cellTextValue}
                </TableCell>
            </Tooltip>
        );
}

const VirtualizedAutocomplete = ({ options, placeholder = "Selected items", maxDisplayTags = 2, itemHeight = 20,
    setLoading, handleFilterClose, handleFilterChange, setSelectedRows, selectedOptionsData }) => {

    const [selectedOptions, setSelectedOptions] = useState(new Set(selectedOptionsData))
    const [inputValue, setInputValue] = useState("")
    const [isOpen, setIsOpen] = useState(true)
    const [scrollTop, setScrollTop] = useState(0)
    const [getOpenAutoComplete, setOpenAutoComplete] = useState(true)

    const containerRef = useRef(null)
    const listRef = useRef(null)
    const searchInputRef = useRef(null)

    const filteredOptions = useMemo(() => {
        if (!inputValue.trim()) return options
        const searchTerm = inputValue?.toLowerCase()
        return options.filter((option) => {
            const label = (option ?? "").toString().toLowerCase();
            return label.includes(searchTerm);
        });
    }, [options, inputValue])

    const [listHeight, setListHeight] = useState(0);

    useEffect(() => {
        if (!listRef.current) {
            return () => { };
        }

        const ro = new ResizeObserver((entries) => {
            setListHeight(entries[0].contentRect.height);
        });

        ro.observe(listRef.current);

        return () => {
            ro.disconnect();
        };
    }, []);

    const visibleItemCount = Math.ceil(listHeight / itemHeight);
    const totalHeight = filteredOptions.length * itemHeight
    const startIndex = Math.floor(scrollTop / itemHeight)
    const endIndex = Math.min(startIndex + visibleItemCount + 1, filteredOptions.length)
    const visibleItems = filteredOptions.slice(startIndex, endIndex)
    const offsetY = startIndex * itemHeight

    const areAllFilteredSelected = useMemo(() => {
        return (
            filteredOptions.length > 0 &&
            filteredOptions.every((option) => selectedOptions.has(option))
        )
    }, [filteredOptions, selectedOptions])

    const handleSelectAll = useCallback(() => {
        setSelectedOptions((prev) => {
            const newSet = new Set(prev)
            if (areAllFilteredSelected) {
                filteredOptions.forEach((option) => newSet.delete(option))
            } else {
                filteredOptions.forEach((option) => newSet.add(option))
            }
            return newSet
        })
    }, [filteredOptions, areAllFilteredSelected])

    const handleItemSelect = useCallback((option) => {
        setSelectedOptions((prev) => {
            const newSet = new Set(prev)
            if (newSet.has(option)) {
                newSet.delete(option)
            } else {
                newSet.add(option)
            }
            return newSet
        })
    }, [])

    const handleScroll = useCallback((e) => {
        setScrollTop(e.currentTarget.scrollTop)
    }, [])

    const removeSelectedItem = useCallback((option) => {
        setSelectedOptions((prev) => {
            const newSet = new Set(prev)
            newSet.delete(option)
            return newSet
        })
    }, [])

    const clearAll = useCallback(() => {
        setSelectedOptions(new Set())
    }, [])

    const selectedArray = useMemo(() => Array.from(selectedOptions), [selectedOptions])
    const selectedSet = useMemo(() => {
        return new Set([...selectedOptions].map(item => item?.toString()));
    }, [selectedOptions]);

    const handleSubmit = () => {
        setLoading(false);
        handleFilterClose();

        const isAllSelected = options.length > 0 && selectedOptions.size === options.length;

        // If all selected - clear filter at source
        handleFilterChange(isAllSelected ? new Set() : selectedSet);

        if (document.activeElement) {
            document.activeElement.blur();
        }

        setSelectedRows([]);

        if (isAllSelected) {
            setSelectedOptions(new Set());
        }
    };

    const handleCancel = () => {
        if (document.activeElement) {
            (document.activeElement).blur()
        }
        setIsOpen(false);
        setOpenAutoComplete(false);
        handleFilterClose();
    }

    const handleOutSideClickCancel = () => {
        if (document.activeElement) {
            (document.activeElement).blur()
        }
        setIsOpen(false);
        setOpenAutoComplete(false);
        handleFilterClose();
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                handleOutSideClickCancel()
            }
        }
        document.addEventListener("mousedown", handleClickOutside)
        return () => document.removeEventListener("mousedown", handleClickOutside)
    }, [])

    useEffect(() => {
        if (isOpen && searchInputRef.current) {
            searchInputRef.current.focus()
        }
    }, [isOpen])

    return (
        <Box ref={containerRef}>
            {isOpen && (
                <Paper
                    elevation={3}
                    sx={{
                        resize: "both",          //  RESIZABLE
                        overflow: "hidden",
                        width: 220,
                        height: 210,
                        minWidth: 200,
                        minHeight: 200,
                        maxWidth: 500,
                        maxHeight: 400,
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        onClick={() => setIsOpen(true)}
                        value=""
                        InputProps={{
                            readOnly: true,
                            startAdornment: (
                                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, whiteSpace: "nowrap" }}>
                                    {selectedArray.length === 0 ? (
                                        <Typography variant="body2" color="text.secondary">
                                            {placeholder}
                                        </Typography>
                                    ) : selectedArray.length <= maxDisplayTags ? (
                                        selectedArray.map((option) => (
                                            <Chip
                                                key={option}
                                                label={option}
                                                size="small"
                                                onDelete={() => removeSelectedItem(option)}
                                                deleteIcon={<CloseIcon />}
                                                sx={{ fontSize: "0.75rem", mr: 0.5 }}
                                            />
                                        ))
                                    ) : (
                                        <>
                                            {selectedArray.slice(0, maxDisplayTags).map((option) => (
                                                <Chip
                                                    key={option}
                                                    label={option}
                                                    size="small"
                                                    onDelete={() => removeSelectedItem(option)}
                                                    deleteIcon={<CloseIcon />}
                                                    sx={{ fontSize: "0.75rem", mr: 0.5 }}
                                                />
                                            ))}
                                            <Chip
                                                label={`+${selectedArray.length - maxDisplayTags} more`}
                                                size="small"
                                                sx={{ fontSize: "0.75rem" }}
                                            />
                                        </>
                                    )}
                                </Box>
                            ),
                            endAdornment: (
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    {selectedArray.length > 0 && (
                                        <IconButton
                                            size="small"
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                clearAll()
                                            }}
                                        >
                                            <ClearIcon fontSize="small" />
                                        </IconButton>
                                    )}
                                </Box>
                            ),
                        }}
                    />

                    {/* Search input */}
                    <TextField
                        inputRef={searchInputRef}
                        fullWidth
                        placeholder="Type to search..."
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        size="small"
                        variant="outlined"
                        sx={{ mt: 0.5, borderBottom: 1, borderColor: "divider", flexShrink: 0, }}
                    />

                    {/* Select All */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            px: 1,
                            height: 30,
                            cursor: "pointer",
                            bgcolor: "grey.50",
                            borderBottom: 1,
                            borderColor: "divider",
                            flexShrink: 0,
                        }}
                        onClick={handleSelectAll}
                    >
                        <Checkbox checked={areAllFilteredSelected} size="small" sx={{ mr: 1 }} /> {/* shrink checkbox padding */}
                        <Typography variant="body2" sx={{ fontSize: "0.75rem", color: "black", }}>
                            Select All
                        </Typography>
                    </Box>

                    {/* Scrollable Options */}
                    <Box
                        ref={listRef}
                        sx={{
                            flex: 1,
                            minHeight: 0,
                            overflow: "auto",
                            position: "relative",
                        }}
                        onScroll={handleScroll}
                    >
                        <Box sx={{ height: totalHeight, position: "relative" }}>
                            <Box sx={{ transform: `translateY(${offsetY}px)` }}>
                                {visibleItems.map((option, index) => {
                                    const actualIndex = startIndex + index
                                    const isSelected = selectedOptions.has(option)
                                    return (

                                        <Tooltip title={option} key={`tooltip-${option}-${actualIndex}`} arrow enterDelay={1000}>
                                            <Box
                                                key={`box-${option}-${actualIndex}`}
                                                sx={{
                                                    height: 25,
                                                    px: 1,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    cursor: "pointer",
                                                    borderBottom: "1px solid",
                                                    borderColor: "divider",
                                                    "&:hover": {
                                                        bgcolor: "grey.50",
                                                    },
                                                }}
                                                onClick={() => handleItemSelect(option)}
                                            >
                                                <Checkbox checked={isSelected} size="small" sx={{ mr: 1 }} />
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        flex: 1,
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                        fontSize: "10px",
                                                        color: "black",
                                                    }}
                                                >
                                                    {option}
                                                </Typography>
                                            </Box>
                                        </Tooltip>

                                    )
                                })}
                            </Box>
                        </Box>
                    </Box>

                    {/* Submit / Cancel Buttons */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 0.5,
                            p: 0.5,
                            borderTop: 1,
                            borderColor: "divider",
                            bgcolor: "grey.50",
                            flexShrink: 0,
                        }}
                    >
                        <Button variant="outlined" size="small" onClick={handleCancel}>
                            Cancel
                        </Button>
                        <Button variant="contained" size="small" onClick={handleSubmit}>
                            Submit
                        </Button>
                    </Box>
                </Paper>
            )}
        </Box>
    )
}

function Filter({ column, myFilterFn, setLoading, setSelectedRows, handleFilterClose }) {

    const columnFilterValue = column.getFilterValue();
    const [selectedOptions, setSelectedOptions] = useState(columnFilterValue ?? []);

    const getUniqueValues = useCallback((column1) => {
        setLoading(true);

        const formatVariant = column.columnDef.meta.formatVariant ?? 'string';
        let returnValue = [];

        switch (formatVariant) {
            case 'string': {
                let filterArray = Array.from(column1.getFacetedUniqueValues().keys()).sort();

                filterArray = filterArray.map(item => {
                    if (typeof item === 'string') {
                        item = item.replace(/\s+$/, ''); // Trim trailing whitespace
                        return item.toUpperCase();
                    }
                    return item;
                });

                const uniqueSet = new Set(filterArray);
                filterArray = [...uniqueSet];

                if (filterArray.includes(undefined)) {
                    returnValue = [];
                } else {
                    returnValue = filterArray[0] !== null ? filterArray : [];
                }
                break;
            }
            case "datetime": {
                const dateTimeValues = Array.from(column1.getFacetedUniqueValues().keys()).sort();

                if (dateTimeValues.length === 0) {
                    returnValue = [];
                } else {
                    const monthMap = {
                        Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
                        Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
                    };

                    const monthNames = [
                        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
                        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
                    ];

                    const parseDateTimeSafe = (value) => {
                        if (!value) return null;

                        // Date object
                        if (value instanceof Date && !Number.isNaN(value.getTime())) {
                            return value;
                        }

                        // ISO / timestamp
                        const d = new Date(value);
                        if (!Number.isNaN(d.getTime())) return d;

                        // DD-MMM-YYYY HH:mm:ss
                        const match = String(value).match(
                            /^(\d{2})-([A-Za-z]{3})-(\d{4})\s+(\d{2}):(\d{2}):(\d{2})$/
                        );

                        if (!match) return null;

                        const [, dd, mon, yyyy, hh, mm, ss] = match;
                        return new Date(yyyy, monthMap[mon], dd, hh, mm, ss);
                    };

                    const formatDateTime = (date) => {
                        const day = String(date.getDate()).padStart(2, "0");
                        const month = monthNames[date.getMonth()];
                        const year = date.getFullYear();

                        const hh = String(date.getHours()).padStart(2, "0");
                        const mm = String(date.getMinutes()).padStart(2, "0");
                        const ss = String(date.getSeconds()).padStart(2, "0");

                        return `${day}-${month}-${year} ${hh}:${mm}:${ss}`;
                    };

                    const formattedArray = dateTimeValues
                        .map(val => {
                            const dt = parseDateTimeSafe(val);
                            return dt ? formatDateTime(dt) : null;
                        })
                        .filter(Boolean)
                        .sort((a, b) => new Date(a) - new Date(b));

                    returnValue = [...new Set(formattedArray)];
                }
                break;
            }
            case "monthdate": {
                const monthValues = Array.from(column1.getFacetedUniqueValues().keys()).sort();

                if (monthValues.length === 0) {
                    returnValue = [];
                }
                else {
                    const monthMap = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11 };
                    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

                    const parseMonthSafe = (value) => {
                        if (!value) return null;

                        // Date object
                        if (value instanceof Date && !isNaN(value.getTime())) {
                            return value;
                        }

                        // ISO / timestamp
                        const d = new Date(value);
                        if (!isNaN(d.getTime())) return d;

                        // DD-MMM-YYYY
                        const match = String(value).match(/^(\d{2})-([A-Za-z]{3})-(\d{4})$/);
                        if (match) {
                            const [, , mon, yyyy] = match;
                            return new Date(yyyy, monthMap[mon], 1);
                        }

                        // MMM-YYYY
                        const monthMatch = String(value).match(/^([A-Za-z]{3})-(\d{4})$/);
                        if (monthMatch) {
                            const [, mon, yyyy] = monthMatch;
                            return new Date(yyyy, monthMap[mon], 1);
                        }

                        return null;
                    };

                    const formattedArray = monthValues
                        .map(val => {
                            const date = parseMonthSafe(val);
                            if (!date) return null;

                            const month = monthNames[date.getMonth()];
                            const year = date.getFullYear();
                            return `${month}-${year}`;
                        })
                        .filter(Boolean)
                        // Sort by actual date value
                        .sort((a, b) => {
                            const da = new Date(`01-${a}`);
                            const db = new Date(`01-${b}`);
                            return da - db;
                        });

                    returnValue = [...new Set(formattedArray)];
                }
                break;
            }
            case "date": {
                const dateValues = Array.from(column1.getFacetedUniqueValues().keys()).sort();

                if (dateValues.length === 0) {
                    returnValue = [];
                } else {
                    const monthMap = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11 };

                    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

                    const parseDateSafe = (value) => {
                        if (!value) return null;

                        // Try normal Date parsing (ISO, timestamp, etc.)
                        const d = new Date(value);
                        if (!isNaN(d.getTime())) return d;

                        // Handle DD-MMM-YYYY (11-Feb-2025)
                        const match = value.match(/^(\d{2})-([A-Za-z]{3})-(\d{4})$/);
                        if (!match) return null;

                        const [, dd, mon, yyyy] = match;
                        return new Date(yyyy, monthMap[mon], dd);
                    };

                    const formattedArray = dateValues
                        .map(dateStr => {
                            const date = parseDateSafe(dateStr);
                            if (!date) return null;

                            const day = String(date.getDate()).padStart(2, '0');
                            const month = monthNames[date.getMonth()];
                            const year = date.getFullYear();
                            return `${day}-${month}-${year}`;
                        })
                        .filter(Boolean);

                    returnValue = [...new Set(formattedArray)];
                }
                break;
            }
            case 'numeric': {
                const numFormat = Array.from(column1.getFacetedUniqueValues().keys()).sort();

                const formattedNumbers = numFormat
                    .map(uniqueValue => {
                        if (uniqueValue === null || uniqueValue === '') return '';

                        return Number(uniqueValue).toString();
                    })
                    .sort((a, b) => Number(a) - Number(b));

                // Remove duplicates
                const uniqueFormattedNumbers = [...new Set(formattedNumbers)];
                returnValue = uniqueFormattedNumbers;
                break;
            }
            case 'decimalnumber': {
                const numFormat = Array.from(column1.getFacetedUniqueValues().keys()).sort();
                const formatedNumbers = numFormat
                    .map(uniqueValue => {
                        if (uniqueValue === null || uniqueValue === '') return '';
                        return Number(uniqueValue).toFixed(2);
                    })
                    .sort((a, b) => a - b);

                const thousnadSeperatedFormattedNumber = formatedNumbers.map(val => {
                    if (val === null || val === '') return '';
                    return Number(val).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    });
                });

                const set = new Set(thousnadSeperatedFormattedNumber);

                const uniqueFormattedNumbers = [...set];

                returnValue = uniqueFormattedNumbers;
                break;
            }
            case 'percentage': {
                const percentValues = Array.from(column1.getFacetedUniqueValues().keys()).sort();

                const formattedPercentages = percentValues
                    .map(value => {
                        if (value === null || value === '' || isNaN(value)) return '';
                        // Convert to number and ensure two decimal places
                        const num = Number(value);
                        return `${num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`;
                    });

                // Remove duplicates and empty strings
                const set = new Set(formattedPercentages.filter(v => v !== ''));
                const uniqueFormattedPercentages = [...set];
                returnValue = uniqueFormattedPercentages;
                break;
            }
            case 'integer': {
                const numValues = Array.from(column1.getFacetedUniqueValues().keys()).sort();
                const formattedIntegers = numValues
                    .map(value => {
                        if (value === null || value === '' || isNaN(value)) return '';
                        return Number(value).toLocaleString("en-IN", {
                            maximumFractionDigits: 0
                        });
                    });

                const set = new Set(formattedIntegers);
                const uniqueFormattedIntegers = [...set];
                returnValue = uniqueFormattedIntegers;
                break;
            }
        }

        // FIXED BLANK LOGIC (ONLY CHANGE)
        const rawValues = Array.from(column1.getFacetedUniqueValues().keys());

        const addBlankValue = rawValues.some(
            v => v === null || v === undefined || v === ''
        );

        const returnValueSet = new Set(returnValue);
        returnValueSet.delete('');
        returnValueSet.delete(null);

        let newReturnValue = addBlankValue
            ? ['(Blank)', ...returnValueSet]
            : [...returnValueSet];

        if (newReturnValue.length === 0) {
            newReturnValue = ['(Blank)'];
        }

        setLoading(false);
        return newReturnValue;
    }, [setLoading]);

    const sortedUniqueValues = useMemo(
        () => getUniqueValues(column),
        [column, getUniqueValues]
    );

    useEffect(() => {
        setSelectedOptions(columnFilterValue ?? []);
    }, [columnFilterValue]);

    const handleFilterChange = useCallback(
        (newValue) => {
            setLoading(true);
            setTimeout(() => {
                if (newValue.length === 0) {
                    column.setFilterValue(undefined);
                } else {
                    column.setFilterValue(newValue);
                }
                setLoading(false);
            }, 2000);
        },
        [column, setLoading],
    );

    useEffect(() => {
        column.columnDef.filterFn = myFilterFn;
    }, [column, myFilterFn]);

    return (
        <Box sx={{ maxWidth: 600, mx: "auto" }}>
            <VirtualizedAutocomplete
                options={sortedUniqueValues}
                maxDisplayTags={1}
                itemHeight={30}
                maxHeight={300}
                setLoading={setLoading}
                handleFilterClose={handleFilterClose}
                handleFilterChange={handleFilterChange}
                setSelectedRows={setSelectedRows}
                selectedOptionsData={selectedOptions}
            />
        </Box>
    );
}

// DebouncedInput Component
function DebouncedInput({ value: initialValue, onChange, debounce = 500, style, ...props }) {
    const [value, setValue] = React.useState(initialValue);

    React.useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);

    React.useEffect(() => {
        const timeout = setTimeout(() => {
            onChange(value);
        }, debounce);

        return () => clearTimeout(timeout);
    }, [value, debounce, onChange]);

    return (
        <input
            {...props}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            style={style}
        />
    );
}

export { Format, Filter, DebouncedInput };
